<agr-page-toolbar
  [pageTitle]="'feed-advice.create-from-reference.title' | translate"
  [hasPrimaryAction]="false"
  data-test="feed-advice-from-reference__overview"
>
  <div class="wrapper--spacing-horizontal">
    <div class="card">
      <agr-summary-card
        [title]="'feed-advice.create-from-reference.scratch-title' | translate"
        [canExpand]="false"
        [actions]="[]"
      >
        <mat-list>
          <mat-list-item class="list-item">
            <p matListItemTitle>
              {{ 'feed-advice.create-from-reference.scratch-option-title' | translate }}
              <span class="subtitle">{{
                'feed-advice.create-from-reference.scratch-option-subtitle' | translate
              }}</span>
            </p>

            <button
              matListItemMeta
              type="button"
              mat-flat-button
              color="accent"
              (click)="fromScratchCreate()"
              data-test="createFromScratch"
            >
              <mat-icon>{{ (ltr$ | async) ? 'arrow_forward' : 'arrow_back' }}</mat-icon>
              {{ 'feed-advice.create-from-reference.scratch-button' | translate }}
            </button>
          </mat-list-item>
        </mat-list>
      </agr-summary-card>
    </div>

    <div class="card" *ngIf="(referenceSchemes$ | async)?.length > 0">
      <agr-summary-card
        [title]="'feed-advice.create-from-reference.reference-schemes-title' | translate"
        [canExpand]="false"
        [actions]="[]"
      >
        <mat-list>
          <mat-list-item
            *ngFor="let referenceScheme of referenceSchemes$ | async"
            class="list-item"
          >
            <p matListItemTitle>
              {{ referenceScheme.name }}
              <span class="subtitle"
                >{{ referenceScheme.productRows.length }}
                <ng-container *ngIf="referenceScheme.productRows.length === 1">{{
                  ('feed-advice.create-from-reference.product' | translate).toLowerCase()
                }}</ng-container>
                <ng-container *ngIf="referenceScheme.productRows.length > 1">{{
                  ('feed-advice.create-from-reference.products' | translate).toLowerCase()
                }}</ng-container>
                <ng-container *ngIf="referenceScheme.additiveRows.length > 0">
                  - {{ referenceScheme.additiveRows.length }}
                  <ng-container *ngIf="referenceScheme.additiveRows.length === 1">{{
                    ('feed-advice.create-from-reference.additive' | translate).toLowerCase()
                  }}</ng-container>
                  <ng-container *ngIf="referenceScheme.additiveRows.length > 1">{{
                    ('feed-advice.create-from-reference.additives' | translate).toLowerCase()
                  }}</ng-container>
                </ng-container>
              </span>
            </p>
            <button
              matListItemMeta
              type="button"
              mat-flat-button
              color="accent"
              (click)="createFeedAdviceFromReference(referenceScheme)"
              data-test="createFromReference'"
            >
              <mat-icon>{{ (ltr$ | async) ? 'arrow_forward' : 'arrow_back' }}</mat-icon>
              {{ 'feed-advice.create-from-reference.reference-schemes-button' | translate }}
              {{ referenceScheme.name }}
            </button>
          </mat-list-item>
        </mat-list>
      </agr-summary-card>
    </div>
  </div>
</agr-page-toolbar>
